import css from 'styled-jsx/css';

export default css.global`.pricing-view-title {
  font-size: 2.5rem;
  color: #2f2e7c;
  text-align: center;
}

.pricing-card {
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #fff;
  overflow: hidden;
}

.pricing-card-header {
  display: flex;
  position: relative;
}

.pricing-card-header p {
  margin: 0;
}

.pricing-card-header .open-trigger {
  width: 40px;
}

.pricing-card-header .title {
  margin-right: auto;
}

.pricing-card-header .title,
.pricing-card-header .sub-title {
  align-self: center;
  padding: 1.7rem;
}

.pricing-card-header .sub-title p:first-child {
  font-weight: 900;
  font-size: 26px;
}

.pricing-card-header .sub-title p:last-child {
  font-weight: 500;
  font-size: 13px;
  color: #989898;
}

.pricing-card-header .title p {
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
}

.pricing-card .open-trigger {
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.pricing-list {
  display: grid;
  gap: 1rem;
  padding: 1rem 1.7rem;
  list-style: none;
}

.pricing-list-item {
  display: flex;
  align-items: flex-start;
  line-height: 1.2;
  position: relative;
}

.pricing-list-item i:hover ~ span {
  display: block;
}

.pricing-list-item span {
  position: absolute;
  background-color: #2f2e7c;
  color: #ffffff;
  max-width: 175px;
  padding: 5px;
  border-radius: 5px;
  left: 13%;
  top: 15px;
  z-index: 1;
  display: none;
}

.pricing-list-item img {
  width: 16px;
  margin-right: 1rem;
}

.pricing-list-item i {
  margin-left: 3px;
  color: #989898;
}

.pricing-card-body .action-cont {
  margin-bottom: 1rem;
  padding: 0 1.5rem 1.5rem;
}

.pricing-card-body .open-trigger {
  width: 100%;
  padding: 1rem;
  text-transform: uppercase;
}

.pricing-card-body .open-trigger i {
  margin-left: 1rem;
}

.pricing-card-body > .title {
  padding: 1rem 1.7rem;
  margin: 0;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
}

.pricing-card-list {
  display: grid;
  gap: 2rem;
}

.pricing-card-list .pricing-card:nth-child(1) {
  border: 1px solid #a13a3a;
}

.pricing-card-list .pricing-card:nth-child(1) .featured {
  background-color: #a13a3a;
}

.pricing-card-list .pricing-card:nth-child(1) .pricing-card-header .title p {
  color: #a13a3a;
}

.pricing-card-list .pricing-card:nth-child(1) button {
  background: #ffe9e9;
  color: #a13a3a;
}

.pricing-card-list .pricing-card:nth-child(2) {
  border: 1px solid #ffe3aa;
}

.pricing-card-list .pricing-card:nth-child(2) .pricing-card-header .title p {
  color: #fdb72b;
}

.pricing-card-list .pricing-card:nth-child(2) button {
  background: #fff7f0;
  color: #fdb72b;
}

.pricing-card-list .pricing-card:nth-child(2) .featured {
  background-color: #fdb72b;
}

.pricing-card-list .pricing-card:nth-child(3) {
  border: 1px solid #33a354;
}

.pricing-card-list .pricing-card:nth-child(3) .pricing-card-header .title p {
  color: #33a354;
}

.pricing-card-list .pricing-card:nth-child(3) button {
  background: #d6ecdc;
  color: #33a354;
}

.pricing-card-list .pricing-card:nth-child(3) .featured {
  background-color: #33a354;
}

.featured {
  position: absolute;
  top: 0;
  left: 0;
  border-bottom-right-radius: 10px;
  color: #fff;
  padding: 3px 24px;
  font-size: 12px;
  font-weight: 500;
}

@media (min-width: 1023px) {
  .pricing-view {
    display: none;
  }
}
`